import React from 'react';
import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';
import filterBlackList from '@laigu/utils/filterBlackList';

import style from './index.less';

const MessageRedbookService = props => {
  const { data = {} } = props;
  const { cover, sub_title, link, title, button_text } = data;

  const picStyle = {
    background: `url(${removeHTMLScript(cover)}) no-repeat`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '180px',
    height: '240px',
    borderRadius: '4px',
    border: '1px solid #E2E5EE'
  };
  const safeUrl = filterBlackList(removeHTMLScript(link));

  const handleCardClick = () => {
    const windowFeatures = 'width=800,height=600,noopener,noreferrer';
    window.open(safeUrl, '_blank', windowFeatures);
  };

  return (
    <div className={style.red_book_card} onClick={handleCardClick}>
      <div style={picStyle} />
      <div>
        <div className={style.title} title={title}>
          {title}
        </div>
        <div className={style.desc}>{sub_title}</div>
      </div>
    </div>
  );
};

export default MessageRedbookService;
